<script>
import ImageWrapper from '@/components/atoms/ImageWrapper'
import Spinner from '@/components/atoms/Spinner'
import Diets from '@/components/atoms/Diets'
import { mapGetters } from 'vuex'

export default {
    name: 'MealCard',
    components: { Diets, ImageWrapper, Spinner },
    props: {
        model: null,
        cart: {
            type: Object,
            default: () => {},
        },
        index: Number,
        max: Number,
        loading: Boolean,
        eager: Boolean,
    },
    data() {
        return {
            show: false,
        }
    },
    created() {
        if (this.eager) this.show = true
    },
    computed: {
        ...mapGetters({
            currency: 'active/currency',
            size: 'size',
            isApple: 'isApple',
        }),

        oneRow() {
            return ['xs', 'sm', 'md', 'lg'].includes(this.size)
        },

        items() {
            return this.cart.items
        },
        isSelected() {
            let quantity
            if (!this.cart.isEmpty)
                quantity = this.cart.items
                    .filter((item) => item.meal === `/api/v1/meals/${this.model.id}`)
                    .reduce((p, c) => p + c.quantity, 0)
            return quantity ? quantity : false
        },
    },
    methods: {
        onClick() {
            this.$emit('click', this.model)
        },
    },
}
</script>

<template lang="pug">    
component.col-12.col-xl-6(v-if="model" :is="eager ? 'div' : 'lazy-component'" @show="show = true")
    .meal-card(:class="{'no-image': !model.image, 'selected': isSelected, 'first': oneRow && !index}" @click="onClick" role="button")
        transition(name="fade")
            spinner(v-if="loading && show" size="15")
        .meal-content
            h3.text-ellipsis-2.text-ellipsis-lg-1
                span.mr-2.text-primary.font-weight-semibold.line-1(v-if="isSelected") {{isSelected}}
                    icon.ml-2.mt-1(icon="fa-solid fa-times" size="xs")
                | {{model.name}}
            p.body-sm.text-73.text-ellipsis-2.content-html.mb-1.test(v-html="model.description" :class="{'hide-unnecessary-content': isApple}")
            .d-flex
                span.text-sm.text-73(v-if="model.kcal" :class="{'separator': model.minimum_quantity > 1 || model.portion_size > 1}") {{model.kcal | toCal}}
                span.text-sm.text-primary(v-if="model.minimum_quantity > 1" :class="{'separator': model.portion_size > 1}") {{$t("meal.min_quantity")}}&nbsp;{{model.minimum_quantity}}
                //- ordit1/tasks/tasks#21: show how many people the portion feeds, next to the minimum quantity, only when portion_size > 1
                //- ordit1/tasks/tasks#21: highlighted (text-primary green) like the minimum quantity, with a small left padding
                span.text-sm.text-primary.pl-1(v-if="model.portion_size > 1") {{$t("meal.feeds", "Feeds: {n} people", {n: model.portion_size})}}
            .d-flex.align-items-center.justify-content-between.flex-wrap.gap-3.mt-lg-auto.position-realtive(:class="{'mt-2':model.description}")
                div(v-if="model.price && currency" :class="model.original_price ? 'text-primary' : 'text-73'") {{model.price | toCurrency(currency.locale, currency.currency_code)}}
                    s.text-73.ml-3(v-if="model.original_price && currency") {{model.original_price | toCurrency(currency.locale, currency.currency_code)}}
                diets(v-if="show" :model="model.suitable_for")
        image-wrapper.meal-image.ml-auto(
            v-if="model.thumb"
            :src="model.thumb"
            :tag="$t('tags.meal_card', {name: model.name})"
            cover)
</template>
